import {PureComponent} from 'react';
import {Button, SVG} from '@br/br-components';

class FbLoginButton extends PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.onFbLogin = this.onFbLogin.bind(this);
  }

  onFbLogin(response) {
    if (response.authResponse) {
      this.props.attemptFbLogin(response.authResponse);
    }
    if (this.props.isSignup) {
      this.props.trackEvent({
        tag_manager_event: 'account_created',
        accountType: 'facebook',
        success: !!response.authResponse,
        socialOnboarding: false,
      });
    }
  }

  onClick() {
    this.props.trackEvent();
    global.FB.login(this.onFbLogin, {scope: 'email'});
  }

  render() {
    return (
      <Button classes="fbLoginButton" onClick={this.onClick}>
        <SVG type="icon" target="facebookFilled" />
        {this.props.children}
      </Button>
    );
  }
}

FbLoginButton.defaultProps = {
  attemptFbLogin: () => {},
  loadScript: () => {},
  trackEvent: () => {},
};

export default FbLoginButton;
